import styled, { css } from "styled-components";

import {
  ContentContainer,
  SectionLastHeading,
  SecondaryButtonComponent,
  CommonTable,
  UnderlineLink,
  DataDescription as CommonDataDescription,
  DataHeading,
  DataValue as CommonDataValue
} from "../../../../CommonComponents/commonStyles";
import { Divider, Modal, Icon } from "antd";

export const GrantGreyBackgroundSection = styled.div`
  background-color: ${props => props.theme.backgroundColor.layoutDark};
  padding: 30px 0px;
  @media only screen and (max-width: 576px) {
    padding: 40px 0px;
  }
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 2.75rem 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 2.75rem 6.4% 0 6.1%;
  }
`;

export const GrantsDashboardBody = styled.div`
  margin-bottom: -24px;
`;

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: 1.13;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
  }
`;

export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 236px;
  display: flex;
  margin-top: -3.25rem;
  justify-content: space-between;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
  }
`;

export const GrantsHead = styled.p`
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-size: ${props => props.theme.fontSize.h2};
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin-bottom: 0.5rem;
`;

export const ActivityHead = styled(GrantsHead)`
  display: inline-block;
  vertical-align: sub;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.h3};
  }
`;

export const GrantsMargin = styled.div`
  margin-bottom: 20px;
`;

export const DateNow = styled.p`
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.lineHeight.normal};
  margin-bottom: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const DataDescription = styled(CommonDataDescription)`
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin: 12px 0 0 0;
  white-space: normal;
  word-break: break-word;
`;

export const DataDescriptionBold = styled(DataDescription)`
  /* //font-weight: bold; */
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const DataHeadingMobile = styled(DataHeading)`
  display: inline-block;
`;

export const DataValue = styled(CommonDataValue)`
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  color: ${props =>
    props.dashboard
      ? props.theme.fontColors.headingColor
      : props.theme.fontColors.textColor};
  white-space: pre-wrap;
  cursor: ${props => (props.showCursor ? "pointer" : "default")};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const UnderlineLinkGrants = styled(UnderlineLink)`
  font-family: ${props =>
    props.dashboard
      ? props.theme.fontFamily.berkeleyStdMedium
      : props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h5};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props =>
    props.disabled
      ? props.theme.fontColors.textColor
      : props.theme.fontColors.primary} !important;
  text-decoration: ${props => (props.disabled ? "none" : "underline")};
  pointer-events: ${props => (props.disabled ? "none" : "all")};
  &:hover :focus {
    color: ${props =>
      props.disabled
        ? props.theme.fontColors.textColor
        : props.theme.fontColors.primary} !important;
    text-decoration: ${props => (props.disabled ? "none" : "underline")};
  }
  a {
    color: ${props =>
      props.disabled
        ? props.theme.fontColors.textColor
        : props.theme.fontColors.primary} !important;
    text-decoration: ${props => (props.disabled ? "none" : "underline")};
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;

export const UnderlineLinkTxn = styled(UnderlineLinkGrants)`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium} !important;
`;

export const DataValueMobile = styled(DataValue)`
  display: inline-block;
`;

export const DashboardDivider = styled(Divider)`
  width: 96%;
  margin: 10px auto;
`;

export const MarginWrapper = styled.div`
  margin-top: 75px;
`;

export const SectionHeading = styled(SectionLastHeading)`
  font-stretch: normal;
  line-height: 1.25;
  font-family: BerkeleyStd;
  letter-spacing: 0.5px;
  color: #022737;
`;

export const SectionDivider = styled(Divider)`
  border: solid 1px #d4d4d4;
  margin-top: 30px;
  margin-bottom: 30px;
`;

export const DeleteModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-header {
      padding: 15px 30px 15px 30px;
      background: #fff;
      border-radius: unset;
      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
    .ant-modal-title {
      text-align: center;
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      font-size: ${props => props.theme.fontSize.h4};
      font-weight: ${props => props.theme.fontWeight.normal};
      line-height: ${props => props.theme.lineHeight.h4};
      color: ${props => props.theme.fontColors.headingColor};
    }
    .ant-modal-footer {
      padding: 16px 20px;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid #dddddd;
      border-radius: 0 0 4px 4px;
    }
  }
`;

export const TableLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: 0.5px;
  color: #022737;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const UnderlyingContent = styled(UnderlineLinkGrants)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 1 rem;
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: #006778;
`;

export const CustomisedIcon = styled(Icon)`
  color: #006778;
`;

export const Title = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 1rem;
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: #022737;
`;

export const GeminiName = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 1rem;
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: #006778;
`;

export const ModalHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.bold};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.oneP17};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: #022737;
  text-align: center;
`;

export const CardPopContainer = styled.div`
  height: 400px;
  overflow-y: auto;
  @media (max-width: 991px) {
    height: 60vh;
  }
  @media (max-width: 425px) {
    height: 40vh;
  }
  @media (max-width: 414px) {
    height: 52vh;
  }
  @media (max-width: 411px) {
    height: 50vh;
  }
  @media (max-width: 375px) {
    height: 44vh;
  }
  @media (max-width: 360px) {
    height: 46vh;
  }
  @media (max-width: 320px) {
    height: 35vh;
  }
`;

export const CustomModal = styled(Modal)`
  .ant-modal-header {
    padding: 0px 0px 30px 0px;
    border-bottom: 2px solid #b6bdbd;
    @media only screen and (max-width: 576px) {
      padding: 0px 0px 15px 0px;
    }
  }
  .ant-modal-footer {
    padding: 30px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    div {
      margin-top: 20px;
    }
    @media only screen and (max-width: 991px) {
      padding-top: 0;
      margin-top: auto;
    }
  }
  .ant-modal-body {
    padding: 12px 0px 10px 0px;
    .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px;
    @media only screen and (max-width: 576px) {
      padding: 30px 20px;
    }

    @media only screen and (max-width: 991px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
  @media only screen and (max-width: 576px) {
    top: 0px !important;
  }
`;

export const GrantsTable = styled(CommonTable).attrs(()=>({
  className: "scrollUp"
  }))`
.ant-table-thead {
  tr {
    th { 
      padding: 0px 16px 10px 0px;
    }
  }
}`;
export const LabelDataHeading = styled(DataHeading)`
  color: ${props => props.theme.fontColors.textColor};
`;

export const ValueDataHeading = styled(DataHeading)`
  color: #505050;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const ContentDivider = styled(Divider)`
  border: #f4f3f3;
  margin-top: 20px;
  margin-bottom: 15px;
`;

export const SectionMediumDivider = styled(Divider)`
  border-bottom: solid 1px ${props => props.theme.colors.border};
  margin-top: ${props => (props.smallMarginTop ? "30px" : "0px")};
  margin-bottom: ${props => (props.smallMarginBottom ? "30px" : "20px")};
  @media only screen and (min-width: 767px) {
    margin-top: ${props => (props.smallMarginTop ? "30px" : "0px")};
    margin-bottom: ${props => (props.smallMarginBottom ? "30px" : "20px")};
  }
`;

export const CharitySectionDivider = styled(Divider)`
  border-bottom: solid 1px ${props => props.theme.colors.border};
  top: unset;
  margin-top: 0px;
  margin-bottom: 20px;
 @media only screen and (min-width: 992px) {
    margin-top: 0px;
   margin-bottom: 20px;
 }`
   

  export const ScrollUp = styled(CharitySectionDivider).attrs(()=>({
    className: "scrollUp"
    }))`` 
  export const TargetDiv = styled.div`
    `
    export const ScrollUpSection = styled(TargetDiv).attrs(()=>({
      className: "scrollUp"
      }))`` 

export const GrantSectionHeading = styled(SectionLastHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  margin-bottom: 15px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h4};
  }
`;

export const GrantSectionSubHeading = styled(SectionLastHeading)`
p{
  display:inline;
  margin:0;
}
a{
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.normal};
  color: rgb(0, 103, 120) !important;
  text-decoration: underline;
}
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  padding: 0px 0px 20px 0px;
  line-height: 1.5rem !important;
  letter-spacing: 0px;
  margin-bottom: 0px !important;
  color: ${props => props.theme.fontColors.thead};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const GrantSecondaryButtonComponent = styled(SecondaryButtonComponent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: 0.875rem;
  > span {
    font-weight: 500;
    padding: 3px 3px 0px 0px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  @media only screen and (max-width: 991.92px) {
    width: 135px;
  }
`;

export const ChartData = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: "100%";
  height: "100%";
  margin: "auto";
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const TabFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NotifyText = styled.span`
  margin-right: 2rem;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
`;

export const UnderlinePurpose = styled.span`
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  cursor: ${props=> props.showCursor ? 'pointer' : 'normal'};
`;

export const DataValueWrapper = styled.span`
  position: relative;
  &:hover ~ div,
  &:hover > div {
    display: block;
  }
`;

export const PointerTriangle = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-bottom: 7px solid ${props => props.theme.backgroundColor.boxToolTip};
  border-right: 6px solid transparent;
  top: -7px;
  left: 30%;
  @media only screen and (min-width: 320px) and (max-width: 523px) {
    left: 16%;
  }
`;

export const Content = styled.div`
  display: none;
  position: absolute;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  backdrop-filter: blur(2px);
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.backgroundColor.boxToolTip};
  padding: 12px 20px;
  font-size: ${props => props.theme.fontSize.secondary};
  color: ${props => props.theme.colors.white};
  border-radius: 4px;
  z-index: 102;
  margin-top: 7px;
  left: -26px;
  max-width: 250px;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    left: -9px;
  }
`;